<template>
  <section id="online" class="section--pt-xlg">
    <div class="inner">
      <h2 class="Head Head--cl01 Head--mg_md">
        <span class="Head__main Head--md">MELON ONLINE CLASS</span><br><span class="Head__main_jp">クラスの選び方</span>
      </h2>
      <p class="_l-lg _mg-b40-30">
        MELONでは「SLEEP」など目的別に20種類以上のマインドフルネスクラスが、13名以上のインストラクターで開催されています。<br><br class="_dsp-none--pc">その日毎に、またインストラクター毎にクラスの内容が違うので、自分に合ったクラス、インストラクターを見つけてください。ここでは、おすすめクラスをご紹介します。
      </p>
    </div>
    <div class="inner">
      <div class="Card__inner Card__archives__inner inner swiper-container ft_en">
        <div class="Card__area Card__archives_area Card__archives_area--recommend">
          <div class="Card__box_list Card__box_list--recommend">
            <div class="Card__box Card__box--recommend Card__box--recommend_basic" @click="openModalRecommend01">
              <div class="Card__box_label Card__box_label_recommend Card__box_label_recommend--two_line ">
                <span>マインドフルネスの<br>基本を体験したい</span>
              </div>
            </div>
          </div>
          <div class="Card__box_list Card__box_list--recommend">
            <div class="Card__box Card__box--recommend Card__box--recommend_sleep" @click="openModalRecommend02">
              <div class="Card__box_label Card__box_label_recommend">
                <span>睡眠を改善したい</span>
              </div>
            </div>
          </div>
          <div class="Card__box_list Card__box_list--recommend">
            <div class="Card__box Card__box--recommend Card__box--recommend_stress" @click="openModalRecommend03">
              <div class="Card__box_label Card__box_label_recommend">
                <span>ストレスを解消したい</span>
              </div>
            </div>
          </div>
          <div class="Card__box_list Card__box_list--recommend">
            <div class="Card__box Card__box--recommend Card__box--recommend_concentration" @click="openModalRecommend04">
              <div class="Card__box_label Card__box_label_recommend">
                <span>集中力を高めたい</span>
              </div>
            </div>
          </div>
          <div class="Card__box_list Card__box_list--recommend">
            <div class="Card__box Card__box--recommend Card__box--recommend_condition" @click="openModalRecommend05">
              <div class="Card__box_label Card__box_label_recommend">
                <span>体調を崩しがち</span>
              </div>
            </div>
          </div>
          <div class="Card__box_list Card__box_list--recommend">
            <div class="Card__box Card__box--recommend Card__box--recommend_relationships" @click="openModalRecommend06">
              <div class="Card__box_label Card__box_label_recommend">
                <span>人間関係を改善したい</span>
              </div>
            </div>
          </div>
          <div class="Card__box_list Card__box_list--recommend">
            <div class="Card__box Card__box--recommend Card__box--recommend_senior" @click="openModalRecommend07">
              <div class="Card__box_label Card__box_label_recommend">
                <span>中上級者の方へ</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <recommend-01
      :is-open="recommend01"
      @close="closeModal"
    />
    <recommend-02
      :is-open="recommend02"
      @close="closeModal"
    />
    <recommend-03
      :is-open="recommend03"
      @close="closeModal"
    />
    <recommend-04
      :is-open="recommend04"
      @close="closeModal"
    />
    <recommend-05
      :is-open="recommend05"
      @close="closeModal"
    />
    <recommend-06
      :is-open="recommend06"
      @close="closeModal"
    />
    <recommend-07
      :is-open="recommend07"
      @close="closeModal"
    />
  </section>
</template>
<script>
import Recommend01 from '@/views/pages/beginner/components/modals/Recommend01.vue'
import Recommend02 from '@/views/pages/beginner/components/modals/Recommend02.vue'
import Recommend03 from '@/views/pages/beginner/components/modals/Recommend03.vue'
import Recommend04 from '@/views/pages/beginner/components/modals/Recommend04.vue'
import Recommend05 from '@/views/pages/beginner/components/modals/Recommend05.vue'
import Recommend06 from '@/views/pages/beginner/components/modals/Recommend06.vue'
import Recommend07 from '@/views/pages/beginner/components/modals/Recommend07.vue'

export default {
  name: 'MelonOnlineClass',
  components: { Recommend01, Recommend02, Recommend03, Recommend04, Recommend05, Recommend06, Recommend07 },
  data() {
    return {
      recommend01: false,
      recommend02: false,
      recommend03: false,
      recommend04: false,
      recommend05: false,
      recommend06: false,
      recommend07: false
    }
  },
  methods: {
    openModalRecommend01() {
      this.recommend01 = true
    },
    openModalRecommend02() {
      this.recommend02 = true
    },
    openModalRecommend03() {
      this.recommend03 = true
    },
    openModalRecommend04() {
      this.recommend04 = true
    },
    openModalRecommend05() {
      this.recommend05 = true
    },
    openModalRecommend06() {
      this.recommend06 = true
    },
    openModalRecommend07() {
      this.recommend07 = true
    },
    closeModal() {
      this.recommend01 = false
      this.recommend02 = false
      this.recommend03 = false
      this.recommend04 = false
      this.recommend05 = false
      this.recommend06 = false
      this.recommend07 = false
    }
  }
}
</script>
